export interface TagOption {
  label: string;
  value: string;
}

export const tagOptions: TagOption[] = [
  { label: "Bad Order", value: "Bad Order" },
  { label: "Congestion Delay/Delay", value: "Congestion Delay/Delay" },
  { label: "Derailment", value: "Derailment" },
  { label: "Dirty Car/Pressure Wash", value: "Dirty Car/Pressure Wash" },
  { label: "Diversion", value: "Diversion" },
  { label: "Fuel", value: "Fuel" },
  { label: "Impact", value: "Impact" },
  { label: "Out of Route", value: "Out of Route" },
  { label: "Railcar Maintenance", value: "Railcar Maintenance" },
  { label: "Railroad Ticket", value: "Railroad Ticket" },
  { label: "Refrigeration Maintenance", value: "Refrigeration Maintenance" },
  { label: "Refrigeration Shutdown", value: "Refrigeration Shutdown" },
  { label: "Shop", value: "Shop" },
  { label: "Other", value: "Other" },
];
